<template>
  <div class="toggle">
    <button class="toggle" v-bind:class="{active : toggle == 'slider'}" @click="toggleAction('slider')"><i class="fas fa-grip-lines"></i></button>
    <button class="toggle" v-bind:class="{active : toggle == 'column'}" @click="toggleAction('column')"><i class="fas fa-grip-vertical"></i></button>
    
    <!-- <i class="fas fa-ellipsis-v"></i> -->
    <!-- <i class="fas fa-ellipsis-h"></i> -->
  </div>
</template>

<script>
export default {
  props: ['toggle'],
  methods: {
    toggleAction(d) {
      this.$emit("toggleAction", d);
    }
  }
}
</script>

<style lang="scss">
  .toggle {
    @include header_toggle();
  }
</style>